"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertImageUrl = void 0;
function convertImageUrl(secureUrl) {
    return secureUrl.replace('https://res.cloudinary.com/', '/image/');
}
exports.convertImageUrl = convertImageUrl;
